import { render, staticRenderFns } from "./costHelpSpa.vue?vue&type=template&id=b3e15104&"
import script from "./costHelpSpa.vue?vue&type=script&lang=js&"
export * from "./costHelpSpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3e15104')) {
      api.createRecord('b3e15104', component.options)
    } else {
      api.reload('b3e15104', component.options)
    }
    module.hot.accept("./costHelpSpa.vue?vue&type=template&id=b3e15104&", function () {
      api.rerender('b3e15104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mQHwZCKPj5nm/JS/comp/costHelpSpa.vue"
export default component.exports